import './PreventiveHeader.scss';

import { useDispatch } from "react-redux";

import { openDrawer } from "../../../slices/drawerSlice";

import Add from "@mui/icons-material/Add";

import { LargeTitle } from "../../../common-components/Titles/Titles";
import { Button } from "../../../common-components/Buttons/Buttons";

import PreventiveReportCreate from "../PreventiveReportCreate/PreventiveReportCreate";
import PreventiveReportCreateFooter
    from "../PreventiveReportCreate/components/PreventiveReportCreateFooter/PreventiveReportCreateFooter";

const PreventiveHeader = () => {
    const dispatch = useDispatch();

    const handleOpen = () => {
        dispatch(openDrawer({content: <PreventiveReportCreate/>, footer: <PreventiveReportCreateFooter/>}));
    }

    return (
        <div className={"preventive-header"}>
            <div className={"preventive-header_container"}>
                <div className={"preventive-header_title"}>
                    <LargeTitle property={"Профилактические выезды"}/>
                </div>
                <div className={"preventive-header_button"}>
                    <Button Icon={Add} title={"Добавить"} onClick={handleOpen}/>
                </div>
            </div>
        </div>
    )
}

export default PreventiveHeader;